module.exports = __webpack_public_path__ + "static/media/colin-devries.7e717b5e.jpeg";